import { Col, Button } from "reactstrap";

function Card(props) {

  const handleClick = () => {
    props.onCardClick(props.card);
  };

  return (
    <Col lg="3" className="text-center">
      <Button className="gallery-img-button" onClick={handleClick}>
        <img src={props.card.CoverImage} alt={props.card.Description} />
      </Button>
      <Button onClick={handleClick} size="sm" color="primary">
        Select
      </Button>
    </Col>
  );
}

export default Card;
